export enum IconSizeEnum {
  small = 'small',
  medium = 'medium',
  large = 'large',
}

interface CategorySizePositionType {
  xPosition: number;
  yPosition: number;
}
interface CategoryIconMapType {
  [category: string]: {
    small: CategorySizePositionType;
    medium: CategorySizePositionType;
    large: CategorySizePositionType;
  };
}

const categoryIconMap: CategoryIconMapType = {
  personal: {
    small: {
      xPosition: -268,
      yPosition: -40,
    },

    medium: {
      xPosition: -162,
      yPosition: -28,
    },

    large: {
      xPosition: -4,
      yPosition: 0,
    },
  },

  design: {
    small: {
      xPosition: -268,
      yPosition: -144,
    },

    medium: {
      xPosition: -162,
      yPosition: -132,
    },

    large: {
      xPosition: -4,
      yPosition: -104,
    },
  },

  education: {
    small: {
      xPosition: -268,
      yPosition: -248,
    },

    medium: {
      xPosition: -162,
      yPosition: -236,
    },

    large: {
      xPosition: -4,
      yPosition: -208,
    },
  },

  'operations-hr': {
    small: {
      xPosition: -268,
      yPosition: -352,
    },

    medium: {
      xPosition: -162,
      yPosition: -340,
    },

    large: {
      xPosition: -4,
      yPosition: -312,
    },
  },

  'team-management': {
    small: {
      xPosition: -268,
      yPosition: -456,
    },

    medium: {
      xPosition: -162,
      yPosition: -444,
    },

    large: {
      xPosition: -4,
      yPosition: -416,
    },
  },

  support: {
    small: {
      xPosition: -268,
      yPosition: -560,
    },

    medium: {
      xPosition: -162,
      yPosition: -548,
    },

    large: {
      xPosition: -4,
      yPosition: -520,
    },
  },

  'project-management': {
    small: {
      xPosition: -268,
      yPosition: -664,
    },

    medium: {
      xPosition: -162,
      yPosition: -652,
    },

    large: {
      xPosition: -4,
      yPosition: -624,
    },
  },

  business: {
    small: {
      xPosition: -268,
      yPosition: -768,
    },

    medium: {
      xPosition: -162,
      yPosition: -756,
    },

    large: {
      xPosition: -4,
      yPosition: -728,
    },
  },

  'product-management': {
    small: {
      xPosition: -268,
      yPosition: -872,
    },

    medium: {
      xPosition: -162,
      yPosition: -860,
    },

    large: {
      xPosition: -4,
      yPosition: -832,
    },
  },

  sales: {
    small: {
      xPosition: -268,
      yPosition: -976,
    },

    medium: {
      xPosition: -162,
      yPosition: -964,
    },

    large: {
      xPosition: -4,
      yPosition: -936,
    },
  },

  productivity: {
    small: {
      xPosition: -268,
      yPosition: -1080,
    },

    medium: {
      xPosition: -162,
      yPosition: -1068,
    },

    large: {
      xPosition: -4,
      yPosition: -1040,
    },
  },

  marketing: {
    small: {
      xPosition: -268,
      yPosition: -1184,
    },

    medium: {
      xPosition: -162,
      yPosition: -1172,
    },

    large: {
      xPosition: -4,
      yPosition: -1144,
    },
  },

  engineering: {
    small: {
      xPosition: -268,
      yPosition: -1288,
    },

    medium: {
      xPosition: -162,
      yPosition: -1276,
    },

    large: {
      xPosition: -4,
      yPosition: -1248,
    },
  },
};

export const getCategoryIconImageCSS = (
  category: string,
  iconSize: IconSizeEnum,
): React.CSSProperties => {
  // TODO: https://trello.atlassian.net/browse/WLRS-769
  // this is a temporary solution until we have a new all templates icon made
  if (category === 'all') {
    return {
      backgroundImage: `url('${require('resources/images/icon-board-outline-blue.svg')}')`,
      backgroundSize: 'cover',
    };
  }

  // fallsback to the first icon in case we add a category but forget to add an icon
  const categorySizeMap = categoryIconMap[category] || {
    small: { xPosition: -268, yPosition: -40 },
    medium: { xPosition: -162, yPosition: -28 },
    large: { xPosition: -4, yPosition: 0 },
  };
  const positions = categorySizeMap[iconSize];

  return {
    backgroundImage: `url('${require('resources/images/templates/category-sprite@2x.png')}')`,
    backgroundPositionY: `${positions.yPosition}px`,
    backgroundPositionX: `${positions.xPosition}px`,
    backgroundSize: '293px 1352px',
  };
};

export const templateUrlSlug = (
  category: string,
  name: string,
  shortLink: string,
) => {
  return `${category}/${(name || '')
    .replace(/\s+/g, '-')
    .toLowerCase()}-${shortLink}`;
};

export const Helpers = {
  getCategoryIconImageCSS,
  IconSizeEnum,
};
